import {AnimatePresence, motion} from 'framer-motion'
import {useEffect, useState} from 'react'
import {isAuthenticated} from '../authentication/AuthUtils'
import {LoadingIcon} from './LoadingIcon'
import {loadingEvent} from './LoadingService'
import './loading.css'

const LoadingScreen = () => {
    const [show, setShow] = useState(false)
    const [text, setText] = useState('')

    useEffect(() => {
        loadingEvent.on('LOADING_SCREEN', (show, text) =>
            showLoading(show, text),
        )

        return () =>
            loadingEvent.removeListener('LOADING_SCREEN', show =>
                showLoading(show),
            )
    }, [])

    useEffect(() => {
        const shouldShowLoading = localStorage.getItem('showLoading')
            ? JSON.parse(localStorage.getItem('showLoading'))
            : false

        if (isAuthenticated() && !!shouldShowLoading) {
            const mainContainer = document.getElementById(
                'layout-main-container-wrapper',
            )
            if (!!mainContainer) {
                mainContainer.classList.add('hidden')
            }

            showLoading(true)
        }
        const timer = setTimeout(() => {
            const mainContainer = document.getElementById(
                'layout-main-container-wrapper',
            )
            if (!!mainContainer) {
                mainContainer.classList.remove('hidden')
            }

            showLoading(false)
            localStorage.setItem('showLoading', false)
        }, 3800)
        return () => {
            clearTimeout(timer)
        }
    }, [])

    const showLoading = (show, text = '') => {
        if (show) {
            document.body.classList.add('noscroll-loading')
            setText(text ? text : '')
        } else {
            document.body.classList.remove('noscroll-loading')
            setText('')
        }

        setShow(show)
    }

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    key={'loading-wrapper'}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0, height: 0}}
                    transition={{duration: 0.05}}>
                    <div
                        id="loading-screen"
                        style={{
                            position: 'fixed',
                            zIndex: 30000,
                            height: '100vh',
                            width: '100vw',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'white',
                        }}>
                        <div className="flex flex-column align-items-center justify-content-center h-full w-full">
                            <div className="mb-8">
                                <LoadingIcon />
                            </div>
                            {!text && (
                                <div>
                                    <div className="text-center">
                                        <h3 className="font-bold">
                                            Welcome back,{' '}
                                            {localStorage.getItem('fullName')}
                                        </h3>
                                        <p>
                                            Your health and well-being are our
                                            top priority - Small steps lead to
                                            big improvements
                                        </p>
                                    </div>
                                </div>
                            )}

                            {!!text && (
                                <div>
                                    <div className="text-center">
                                        <h3 className="font-bold">{text}</h3>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default LoadingScreen
